import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import FormCheckbox from '../../Fields/FormCheckbox.js';

import { getPersonDeontologies, postPersonDeontologies } from '../../Api/UserActions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'

class Confirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.onSelectChange = this.onSelectChange.bind(this);
        this.overview = this.overview.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getPersonDeontologies((data) => {
            this.setState({
                personDeontologies: data
            });
        });
    }

    overview() {
        if (this.props.onOverview == null)
            return;

        this.props.onOverview();
    }

    saveData() {
        return new Promise(resolve => {
            postPersonDeontologies(null, this.state.personDeontologies.carriereInfo, this.state.personDeontologies.news, null, (data) => {
                resolve(data != null);
            });
        });
    }

    onSelectChange(e) {
        var deontologies = update(this.state.personDeontologies, {[e.target.id]: {$set: e.target.checked}});
        this.setState({
            personDeontologies: deontologies
        }, () => {
            this.saveData();
        });  
    } 

    render() {

        if (this.state.personDeontologies == null) {
            return (
                <Loading/>
            );
        }
      
        return (
            <div>
                <h4 className="legend-title">{getTranslation("sns.webparts.confirmation.newsletters")}</h4>

                <FormCheckbox id="carriereInfo"
                    text={getTranslation("sns.webparts.confirmation.carriereinfo")}
                    value={this.state.personDeontologies.carriereInfo}
                    onChange={this.onSelectChange} />

                <FormCheckbox id="news"
                    text={getTranslation("sns.webparts.confirmation.news")}
                    value={this.state.personDeontologies.news}
                    onChange={this.onSelectChange} />

                <h4 className="legend-title">{getTranslation("sns.webparts.confirmation.overview")}</h4>
                
                <div>
                    <input type="button" id="overviewbutton"
                        className="FormButton btn btn-primary overview blue act"
                        value={getTranslation("sns.custom.jobapply.overview")}
                        onClick={this.overview} />
                </div>
            </div>
        );
    }
}

export default Confirmation;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Confirmation.js